// Configuración de versión para forzar recargas automáticas
// Incrementar VERSION_NUMBER cuando se necesite forzar recarga en todos los usuarios

export const VERSION_CONFIG = {
  VERSION_NUMBER: '1.0.1', // Incrementar este número para forzar recarga
  CHECK_INTERVAL: 30000, // Verificar cada 30 segundos
  STORAGE_KEY: 'app_version'
};

/**
 * Obtiene la versión actual almacenada en localStorage
 * @returns {string|null} - Versión almacenada o null si no existe
 */
export const getStoredVersion = () => {
  return localStorage.getItem(VERSION_CONFIG.STORAGE_KEY);
};

/**
 * Almacena la versión actual en localStorage
 * @param {string} version - Versión a almacenar
 */
export const setStoredVersion = (version) => {
  localStorage.setItem(VERSION_CONFIG.STORAGE_KEY, version);
};

/**
 * Verifica si la versión actual es diferente a la almacenada
 * @returns {boolean} - true si hay una nueva versión
 */
export const hasNewVersion = () => {
  const storedVersion = getStoredVersion();
  return storedVersion !== null && storedVersion !== VERSION_CONFIG.VERSION_NUMBER;
};

/**
 * Inicializa la versión en localStorage si no existe
 */
export const initializeVersion = () => {
  const storedVersion = getStoredVersion();
  if (!storedVersion) {
    setStoredVersion(VERSION_CONFIG.VERSION_NUMBER);
  }
};